import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Session } from '../models/session.interface';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private _session: BehaviorSubject<Session> = new BehaviorSubject<Session>(null);
  public session: Observable<Session> = this._session.asObservable();

  private _userPermission: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public userPermission: Observable<any[]> = this._userPermission.asObservable();

  private _causalRequestUserPermission: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public causalRequestUserPermission: Observable<any[]> = this._causalRequestUserPermission.asObservable();

  constructor() { }

  public setSession(session: any): void {
    this._session.next(session);
  }

  public get getSession(): any {
    return this._session.getValue();
  }

  /**
   * Aggiorna SOLO i campi-preferenza (lingua/fuso/menu) sulla sessione legacy esistente,
   * preservando identità e resto del bag. Usato per idratare il legacy dai valori EFFETTIVI
   * del Workspace (migrazione runtime), senza ricostruire l'intera sessione. No-op se la
   * sessione non è ancora stata creata (bootstrap legacy non avvenuto).
   */
  public patchPreferences(p: { defaultLanguage?: string; ianaTimezone?: string; menuState?: boolean }): void {
    const cur = this._session.getValue();
    if (!cur) return;
    const next: any = { ...cur };
    if (p.defaultLanguage != null) next.defaultLanguage = p.defaultLanguage;
    if (p.ianaTimezone != null) next.ianaTimezone = p.ianaTimezone;
    if (p.menuState != null) next.menuState = p.menuState;
    this._session.next(next);
  }

  public get getTimezone(): any {
    return this.getSession?.ianaTimezone;
  }

  public get getLanguage(): any {
    return this._session.getValue() ? (this._session.getValue()).defaultLanguage : 'it';
  }

  public get getPartySharedDefaultView(): any {
    return this._session.getValue()?.partySharedViewDefault;
  }

  public get presenceTimeFormat(): any {
    return this._session.getValue()?.presenceTimeEditor;
  }

  public get attendanceValidLULDate(): any {
    return this._session.getValue()?.attendanceValidLULDate;
  }

  public get userName(): any {
    return this._session.getValue() ? (this._session.getValue()).userName : null;
  }

  public get fullName(): any {
    return this._session.getValue() ? (this._session.getValue()).fullName : null;
  }

  public get email(): any {
    return this._session.getValue() ? (this._session.getValue()).email : null;
  }

  public get relationTypologies(): any {
    return this._session.getValue() ? (this._session.getValue()).relationTypologies : null;
  }

  public setUserPermission(userPermission: any): void {
    this._userPermission.next(userPermission);
  }

  public get getUserPermission(): any {
    return this._userPermission.getValue();
  }

  public setCausalRequestUserPermission(causalRequestUserPermission: any): void {
    this._causalRequestUserPermission.next(causalRequestUserPermission);
  }

  public get causalRequestUserPerm(): any {
    return this._causalRequestUserPermission.getValue();
  }
}
